import React, { useEffect, useState } from "react";
import { Container, Row, Col, FormCheckbox } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import { Link } from "react-router-dom";
import axios from "../../libs/axios";
import useAlert from "../../hooks/alerts";
import TableView from "../../components/Table/Table";
import { formatDateYearMonthDay } from "../../utils/formatting";

const Cases = () => {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);

  const { dispatchAlert } = useAlert();

  const getCases = () => {
    setLoading(true);
    axios
      .get("/cases/table")
      .then((res) => {
        if (res.data.data?.error) {
          dispatchAlert({
            open: true,
            type: "danger",
            message: res.data.data.error,
          });
          return;
        }
        setCases(res.data.data || []);
      })
      .catch((err) => {
        console.error(err);
        dispatchAlert({
          open: true,
          message: err,
          type: "danger",
          timeout: 5000,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getCases();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatAddress = (caseItem) => {
    // {caseItem.street_address +
    //   `${
    //     caseItem.street_address2
    //       ? ", " + caseItem.street_address2
    //       : ""
    //   }`}
    const { street_address, street_address2 } = caseItem;
    let addString = "";
    if (street_address) {
      addString += street_address;
    }
    if (street_address2) {
      addString += ", " + street_address2;
    }
    return addString;
  };

  const formatResidents = (caseItem) => {
    const { residents } = caseItem;
    if (!residents || residents.length === 0) return { display: "", value: "" };

    const names = residents.map((r) =>
      `${r.first_name || ""} ${r.last_name || ""}`.trim()
    );

    return {
      // For display: JSX with line breaks
      display: names.map((name, idx) => (
        <React.Fragment key={idx}>
          {name}
          {idx < names.length - 1 && <br />}
        </React.Fragment>
      )),
      // For search: all names concatenated (searchable string)
      value: names.join(" "),
    };
  };

  const columns = [
    {
      name: "Created At",
    },
    {
      name: "Property Owner",
    },
    {
      name: "Property Management",
    },
    {
      name: "Residents",
    },
    {
      name: "Address",
    },
    {
      name: "Case Number",
    },
  ];

  const rows = cases.map((caseItem) => {
    const residentsFormatted = formatResidents(caseItem);
    const addressFormatted = formatAddress(caseItem);
    const caseNumber = caseItem.court_case_number || "";
    return {
      id: caseItem.id,
      api_endpoint: `/organizations/${caseItem.organization_id}/cases/${caseItem.id}`,
      endpoint: `/cases/${caseItem.id}/${caseItem.organization_id}`,
      fullRecord: caseItem,
      columns: [
        {
          display: formatDateYearMonthDay(caseItem.created_at),
          value: caseItem.created_at,
        },
        {
          display: caseItem.owner?.business_legal_name || "",
          value: caseItem.owner?.business_legal_name || "",
        },
        {
          display: caseItem.organization?.name || "",
          value: caseItem.organization?.name || "",
        },
        {
          display: residentsFormatted.display,
          value: residentsFormatted.value,
        },
        {
          display: addressFormatted,
          value: addressFormatted,
        },
        {
          display: caseNumber,
          value: caseNumber,
        },
      ],
    };
  });

  const [onlyActive, setOnlyActive] = useState(false);

  const sortedRows = [...rows].sort((a, b) => {
    return (
      new Date(b.fullRecord.created_at) - new Date(a.fullRecord.created_at)
    );
  });

  const filteredRows = sortedRows.filter((row) => {
    if (onlyActive) {
      return !!row.fullRecord.active;
    }
    return true;
  });

  if (loading) {
    return <div className="loader mt-7" />;
  }

  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="4"
          title="Cases"
          subtitle="Case management"
          className=""
        />
        <Link className="btn btn-primary btn-lg" to="/cases/add">
          New Case
        </Link>
      </Row>
      <Row>
        <Col>
          <FormCheckbox
            checked={onlyActive}
            onChange={() => setOnlyActive(!onlyActive)}
            className="text-primary"
          >
            Only Active Cases
          </FormCheckbox>
        </Col>
      </Row>
      <br />

      <Row>
        <Col>
          <TableView
            name="Active Cases"
            columns={columns}
            rows={filteredRows}
            refreshTable={getCases}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Cases;
